import { atom } from 'jotai';
import { MutableRefObject } from 'react';

export const ListContainerRef = atom<MutableRefObject<HTMLDivElement | null> | null>(null);
